"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.URLTooLongError = exports.UpgradeRequiredError = exports.UnsupportedMediaTypeError = exports.UnprocessableEntityError = exports.UnavaliableForLegalReasonsError = exports.UnauthorizedError = exports.TooManyRequestsError = exports.RequestedRangeNotSatisfiableError = exports.RequestTooLargeError = exports.RequestTimeoutError = exports.RequestHeaderTooLargeError = exports.ProxyAuthenticationRequiredError = exports.PreconditionRequiredError = exports.PreconditionFailedError = exports.PolicyNotFulfilledError = exports.PaymentRequiredError = exports.NotFoundError = exports.NotAcceptableError = exports.MisdirectedRequestError = exports.MethodNotAllowedError = exports.LockedError = exports.LengthRequiredError = exports.ImATeapotError = exports.GoneError = exports.ForbiddenError = exports.FailedDependencyError = exports.ExpectationFailedError = exports.ConflictError = exports.BadRequestError = exports.AuthenticationTimeoutError = void 0;
const BaseError_1 = require("./BaseError");
const ErrorCodes_1 = require("./ErrorCodes");
class AuthenticationTimeoutError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.AuthenticationTimeoutError, message);
    }
}
exports.AuthenticationTimeoutError = AuthenticationTimeoutError;
class BadRequestError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.BadRequestError, message);
    }
}
exports.BadRequestError = BadRequestError;
class ConflictError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.ConflictError, message);
    }
}
exports.ConflictError = ConflictError;
class ExpectationFailedError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.ExpectationFailedError, message);
    }
}
exports.ExpectationFailedError = ExpectationFailedError;
class FailedDependencyError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.FailedDependencyError, message);
    }
}
exports.FailedDependencyError = FailedDependencyError;
class ForbiddenError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.ForbiddenError, message);
    }
}
exports.ForbiddenError = ForbiddenError;
class GoneError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.GoneError, message);
    }
}
exports.GoneError = GoneError;
class ImATeapotError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.ImATeapotError, message);
    }
}
exports.ImATeapotError = ImATeapotError;
class LengthRequiredError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.LengthRequiredError, message);
    }
}
exports.LengthRequiredError = LengthRequiredError;
class LockedError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.LockedError, message);
    }
}
exports.LockedError = LockedError;
class MethodNotAllowedError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.MethodNotAllowedError, message);
    }
}
exports.MethodNotAllowedError = MethodNotAllowedError;
class MisdirectedRequestError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.MisdirectedRequestError, message);
    }
}
exports.MisdirectedRequestError = MisdirectedRequestError;
class NotAcceptableError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.NotAcceptableError, message);
    }
}
exports.NotAcceptableError = NotAcceptableError;
class NotFoundError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.NotFoundError, message);
    }
}
exports.NotFoundError = NotFoundError;
class PaymentRequiredError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.PaymentRequiredError, message);
    }
}
exports.PaymentRequiredError = PaymentRequiredError;
class PolicyNotFulfilledError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.PolicyNotFulfilledError, message);
    }
}
exports.PolicyNotFulfilledError = PolicyNotFulfilledError;
class PreconditionFailedError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.PreconditionFailedError, message);
    }
}
exports.PreconditionFailedError = PreconditionFailedError;
class PreconditionRequiredError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.PreconditionRequiredError, message);
    }
}
exports.PreconditionRequiredError = PreconditionRequiredError;
class ProxyAuthenticationRequiredError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.ProxyAuthenticationRequiredError, message);
    }
}
exports.ProxyAuthenticationRequiredError = ProxyAuthenticationRequiredError;
class RequestHeaderTooLargeError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.RequestHeaderTooLargeError, message);
    }
}
exports.RequestHeaderTooLargeError = RequestHeaderTooLargeError;
class RequestTimeoutError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.RequestTimeoutError, message);
    }
}
exports.RequestTimeoutError = RequestTimeoutError;
class RequestTooLargeError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.RequestTooLargeError, message);
    }
}
exports.RequestTooLargeError = RequestTooLargeError;
class RequestedRangeNotSatisfiableError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.RequestedRangeNotSatisfiableError, message);
    }
}
exports.RequestedRangeNotSatisfiableError = RequestedRangeNotSatisfiableError;
class TooManyRequestsError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.TooManyRequestsError, message);
    }
}
exports.TooManyRequestsError = TooManyRequestsError;
class UnauthorizedError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.UnauthorizedError, message);
    }
}
exports.UnauthorizedError = UnauthorizedError;
class UnavaliableForLegalReasonsError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.UnavaliableForLegalReasonsError, message);
    }
}
exports.UnavaliableForLegalReasonsError = UnavaliableForLegalReasonsError;
class UnprocessableEntityError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.UnprocessableEntityError, message);
    }
}
exports.UnprocessableEntityError = UnprocessableEntityError;
class UnsupportedMediaTypeError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.UnsupportedMediaTypeError, message);
    }
}
exports.UnsupportedMediaTypeError = UnsupportedMediaTypeError;
class UpgradeRequiredError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.UpgradeRequiredError, message);
    }
}
exports.UpgradeRequiredError = UpgradeRequiredError;
class URLTooLongError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.URLTooLongError, message);
    }
}
exports.URLTooLongError = URLTooLongError;
//# sourceMappingURL=ClientErrors.js.map